export default {
  partner:
    'Defina a sua taxa de processamento do Stripe ou confirme uma margem de 0%. Até lá, os seus restaurantes no Stripe não podem entrar em funcionamento.',
  partner_live_one:
    'Defina a sua taxa de processamento do Stripe ou confirme uma margem de 0%. Até lá, os seus restaurantes no Stripe não podem entrar em funcionamento e o seu restaurante ativo não aceita pagamentos online.',
  partner_live_other:
    'Defina a sua taxa de processamento do Stripe ou confirme uma margem de 0%. Até lá, os seus restaurantes no Stripe não podem entrar em funcionamento e os seus {{count}} restaurantes ativos não aceitam pagamentos online.',
  restaurant:
    'Os pagamentos online estão suspensos até o seu parceiro definir a respetiva taxa de processamento. Os pagamentos em numerário continuam a funcionar.',
  cta: 'Definir taxa de processamento',
};
